import { API_URL } from '../../../../../utils/config';

const KPI_URL = `${API_URL}/kpi/`;
export const GET_KPIS_URL = `${KPI_URL}department/`;
export const GET_ALL_KPIS_URL = `${KPI_URL}listKpi/1`;
export const ADD_KPI_URL = `${KPI_URL}add`;
export const GET_KPI_PERCENTAGE_URL = `${KPI_URL}count/count/`;
export const SEARCH_KPI_URL = `${KPI_URL}searchKpi`;
export const EDIT_KPI_URL = `${KPI_URL}user`;
